<template>
    <div class="calendar-nav">
        <div>
            <b-button
                :disabled="$fetchState.pending || skipVal === 0"
                class="mx-0 button is-subtle"
                :icon-left="
                    $fetchState.pending
                        ? 'fas fa-spinner fa-spin'
                        : 'fas fa-arrow-left'
                "
                @click="pageDown"
            >
            </b-button>

            <b-button
                :disabled="
                    $fetchState.pending || skipVal + firstVal >= totalMembers
                "
                class="mx-0 button is-subtle"
                :icon-left="
                    $fetchState.pending
                        ? 'fas fa-spinner fa-spin'
                        : 'fas fa-arrow-right'
                "
                @click="pageUp"
            >
            </b-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "CalendarNav",
    components: {
        // IconSystem,
        // IconLight,
        // IconDark,
        // IconSepia,
    },
};
</script>

<style lang="scss" scoped>
.grid-container {
    width: 100%;
    display: grid;
    grid-gap: 1rem;
    padding-bottom: 1rem;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    grid-template-rows: repeat(auto-fill, minmax(120px, 1fr));
    justify-items: center;
    align-items: center;
    justify-content: center;
    align-content: center;
    max-width: 90vw;
    /* grid-auto-rows: 1fr; */
}
</style>